import React from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@mui/material';
import { Logout as LogoutIcon } from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';

interface LogoutButtonProps {
  variant?: 'text' | 'outlined' | 'contained';
  size?: 'small' | 'medium' | 'large';
  sx?: any;
}

const LogoutButton: React.FC<LogoutButtonProps> = ({ 
  variant = 'outlined', 
  size = 'medium',
  sx = {}
}) => {
  const [openDialog, setOpenDialog] = React.useState(false);
  const { logout } = useAuth();

  const handleLogout = () => {
    setOpenDialog(false);
    logout();
  };

  return (
    <>
      <Button
        variant={variant}
        size={size}
        startIcon={<LogoutIcon />}
        onClick={() => setOpenDialog(true)}
        sx={{
          color: variant === 'contained' ? 'white' : variant === 'text' ? 'text.primary' : 'error.main',
          borderColor: variant === 'outlined' ? 'error.main' : undefined,
          '&:hover': {
            backgroundColor: variant === 'contained' ? 'error.dark' : variant === 'text' ? 'rgba(0, 0, 0, 0.04)' : 'error.light',
            color: variant === 'contained' ? 'white' : variant === 'text' ? 'text.primary' : 'error.dark',
          },
          ...sx
        }}
      >
        Sair
      </Button>

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          Confirmar Saída
        </DialogTitle>
        <DialogContent>
          <Typography>
            Tem certeza que deseja sair do sistema?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>
            Cancelar
          </Button>
          <Button 
            onClick={handleLogout} 
            color="error" 
            variant="contained"
          >
            Sair
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default LogoutButton; 